export const menuData_ReadOnly = [
    {
        name: "Home",
        level: "1",
        url: "/Dashboard",
        children: [
            {
                name: "Notō Designer",
                level: "2",
                url: "/",
                children: [
                    {
                        name: "Study Configurator",
                        level: "3",
                        url: "/Designer"
                    },
                    {
                        name: "Paradigm Designer",
                        level: "3",
                        url: "/Paradigms"
                    }
                ]
            },
            {
                name: "Image Services",
                level: "2",
                url: "/",
                children: [
                    {
                        name: "Dashboard",
                        level: "3",
                        url: "/Dashboard"
                    },
                    {
                        name: "Closed Tasks",
                        level: "3",
                        url: "/ClosedTaskDashboard"
                    },
                    {
                        name: "CR Current Tasks",
                        level: "3",
                        url: "/CRCurrentTask"
                    }                                 
                ]
            },
            {
                name: "Admin Setting",
                level: "2",
                url: "/",
                children: [
                    {
                        name: "Global Settings",
                        level: "3",
                        url: "/GlobalSettings"
                    },
                    {
                        name: "Assign Role",
                        level: "3",
                        url: "/AssignUserRoleList"
                    },
                    {
                        name: "Assign User",
                        level: "3",
                        url: "/AssignUserByProject"
                    },
                    {
                        name: "Distributions",
                        level: "3",
                        url: "/DistributionList"
                    },
                    {
                        name: "Notifications",
                        level: "3",
                        url: "/NotificationTemp"
                    },
                    {
                        name: "Notification Rule",
                        level: "3",
                        url: "/NotificationRuleList"
                    }
                ]
            },
            {
                name: "Report",
                level: "2",
                url: "",
                children: [
                    {
                        name: "Global Report Viewer",
                        level: "3",
                        url: "/GlobalReportViewer"
                    }
                ]
            }          
        ]
    },
    {
        name: "Help",
        level: "1",
        url: "/",
        children: [
            {
                name: " ",
                level: "2",
                url: ""
            }]
    },
    {
        name: "Contact Support",
        level: "1",
        url: "/",
        children: [
            {
                name: " ",
                level: "2",
                url: ""
            }]
    },
    {
        name: "About",
        level: "1",
        url: "/AboutUs",
        children: [
            {
                name: " ",
                level: "2",
                url: ""
            }]
    }
]